import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/bundle-calc`;

const bundleClient = axios.create({ baseURL: API, timeout: 20000 });

// ---------- Chain / DEX registry (mirrors backend services/bundle_calc.py) ----------
export const CHAIN_LIMITS = {
  ETH:       { maxWallets: 80,  name: 'Ethereum',       nativeSymbol: 'ETH',   color: 'blue',    defaultPrice: 3000 },
  SOL:       { maxWallets: 8,   name: 'Solana',         nativeSymbol: 'SOL',   color: 'purple',  defaultPrice: 100 },
  BNB:       { maxWallets: 60,  name: 'BNB Chain',      nativeSymbol: 'BNB',   color: 'yellow',  defaultPrice: 300 },
  BASE:      { maxWallets: 80,  name: 'Base',           nativeSymbol: 'ETH',   color: 'indigo',  defaultPrice: 3000 },
  KROWN:     { maxWallets: 120, name: 'Krown Network',  nativeSymbol: 'KROWN', color: 'amber',   defaultPrice: 0.02 },
  ROBINHOOD: { maxWallets: 100, name: 'Robinhood',      nativeSymbol: 'ETH',   color: 'emerald', defaultPrice: 3000 },
  ARBITRUM:  { maxWallets: 100, name: 'Arbitrum One',   nativeSymbol: 'ETH',   color: 'sky',     defaultPrice: 3000 },
  OPTIMISM:  { maxWallets: 100, name: 'OP Mainnet',     nativeSymbol: 'ETH',   color: 'red',     defaultPrice: 3000 },
  POLYGON:   { maxWallets: 120, name: 'Polygon',        nativeSymbol: 'POL',   color: 'violet',  defaultPrice: 0.4 },
  AVALANCHE: { maxWallets: 100, name: 'Avalanche',      nativeSymbol: 'AVAX',  color: 'rose',    defaultPrice: 25 },
  LINEA:     { maxWallets: 100, name: 'Linea',          nativeSymbol: 'ETH',   color: 'cyan',    defaultPrice: 3000 },
  SCROLL:    { maxWallets: 100, name: 'Scroll',         nativeSymbol: 'ETH',   color: 'orange',  defaultPrice: 3000 },
  BLAST:     { maxWallets: 100, name: 'Blast',          nativeSymbol: 'ETH',   color: 'lime',    defaultPrice: 3000 },
  ZKSYNC:    { maxWallets: 80,  name: 'zkSync Era',     nativeSymbol: 'ETH',   color: 'blue',    defaultPrice: 3000 },
  MANTLE:    { maxWallets: 120, name: 'Mantle',         nativeSymbol: 'MNT',   color: 'teal',    defaultPrice: 0.6 },
};

// Fallback registry — used until /api/bundle-calc/chains returns.
// Must stay identical to the backend `DEXES` dict.
export const FALLBACK_DEXES = {
  ETH: [
    { id: 'uniswap_v2', name: 'Uniswap V2', default_fee: 0.30, fee_tiers: [0.30] },
    { id: 'uniswap_v3', name: 'Uniswap V3', default_fee: 0.30, fee_tiers: [0.01, 0.05, 0.30, 1.00] },
    { id: 'uniswap_v4', name: 'Uniswap V4', default_fee: 0.30, fee_tiers: [0.01, 0.05, 0.30, 1.00] },
    { id: 'sushi_v2',   name: 'SushiSwap V2', default_fee: 0.30, fee_tiers: [0.30] },
  ],
  BNB: [
    { id: 'pancake_v2', name: 'PancakeSwap V2', default_fee: 0.25, fee_tiers: [0.25] },
    { id: 'pancake_v3', name: 'PancakeSwap V3', default_fee: 0.25, fee_tiers: [0.01, 0.05, 0.25, 1.00] },
    { id: 'biswap_v2',  name: 'Biswap V2',      default_fee: 0.10, fee_tiers: [0.10] },
  ],
  BASE: [
    { id: 'uniswap_v2', name: 'Uniswap V2', default_fee: 0.30, fee_tiers: [0.30] },
    { id: 'uniswap_v3', name: 'Uniswap V3', default_fee: 0.30, fee_tiers: [0.01, 0.05, 0.30, 1.00] },
    { id: 'uniswap_v4', name: 'Uniswap V4', default_fee: 0.30, fee_tiers: [0.01, 0.05, 0.30, 1.00] },
    { id: 'aerodrome',  name: 'Aerodrome',  default_fee: 0.30, fee_tiers: [0.05, 0.30] },
  ],
  SOL: [
    { id: 'raydium_amm',  name: 'Raydium AMM',    default_fee: 0.25, fee_tiers: [0.25] },
    { id: 'raydium_clmm', name: 'Raydium CLMM',   default_fee: 0.25, fee_tiers: [0.01, 0.05, 0.25, 1.00] },
    { id: 'meteora_dlmm', name: 'Meteora DLMM',   default_fee: 0.30, fee_tiers: [0.05, 0.30, 1.00] },
    { id: 'pumpfun',      name: 'Pump.fun',       default_fee: 1.00, fee_tiers: [1.00] },
    { id: 'orca_whirl',   name: 'Orca Whirlpools', default_fee: 0.30, fee_tiers: [0.01, 0.05, 0.30, 1.00] },
  ],
  KROWN: [
    { id: 'krownscan_v3', name: 'KrownScan DEX', default_fee: 0.30, fee_tiers: [0.01, 0.05, 0.30, 1.00] },
  ],
  ROBINHOOD: [
    { id: 'rh_dex_v2',  name: 'Robinhood DEX V2',    default_fee: 0.30, fee_tiers: [0.30] },
    { id: 'uniswap_v3', name: 'Uniswap V3 (Robinhood)', default_fee: 0.30, fee_tiers: [0.01, 0.05, 0.30, 1.00] },
  ],
  ARBITRUM: [
    { id: 'uniswap_v3', name: 'Uniswap V3', default_fee: 0.30, fee_tiers: [0.01, 0.05, 0.30, 1.00] },
    { id: 'camelot_v3', name: 'Camelot V3', default_fee: 0.30, fee_tiers: [0.05, 0.30, 1.00] },
    { id: 'uniswap_v2', name: 'Uniswap V2', default_fee: 0.30, fee_tiers: [0.30] },
    { id: 'sushi_v2',   name: 'SushiSwap V2', default_fee: 0.30, fee_tiers: [0.30] },
  ],
  OPTIMISM: [
    { id: 'uniswap_v3', name: 'Uniswap V3', default_fee: 0.30, fee_tiers: [0.01, 0.05, 0.30, 1.00] },
    { id: 'velodrome',  name: 'Velodrome V2', default_fee: 0.30, fee_tiers: [0.05, 0.30] },
    { id: 'uniswap_v2', name: 'Uniswap V2', default_fee: 0.30, fee_tiers: [0.30] },
  ],
  POLYGON: [
    { id: 'uniswap_v3',   name: 'Uniswap V3', default_fee: 0.30, fee_tiers: [0.01, 0.05, 0.30, 1.00] },
    { id: 'quickswap_v2', name: 'QuickSwap V2', default_fee: 0.30, fee_tiers: [0.30] },
    { id: 'quickswap_v3', name: 'QuickSwap V3', default_fee: 0.30, fee_tiers: [0.01, 0.05, 0.30, 1.00] },
    { id: 'sushi_v2',     name: 'SushiSwap V2', default_fee: 0.30, fee_tiers: [0.30] },
  ],
  AVALANCHE: [
    { id: 'trader_joe_lb', name: 'Trader Joe v2.1 (LB)', default_fee: 0.30, fee_tiers: [0.05, 0.30, 1.00] },
    { id: 'uniswap_v3',    name: 'Uniswap V3', default_fee: 0.30, fee_tiers: [0.01, 0.05, 0.30, 1.00] },
    { id: 'pangolin_v2',   name: 'Pangolin V2', default_fee: 0.30, fee_tiers: [0.30] },
  ],
  LINEA: [
    { id: 'lynex',      name: 'Lynex', default_fee: 0.30, fee_tiers: [0.05, 0.30] },
    { id: 'pancake_v3', name: 'PancakeSwap V3', default_fee: 0.25, fee_tiers: [0.01, 0.05, 0.25, 1.00] },
    { id: 'uniswap_v3', name: 'Uniswap V3', default_fee: 0.30, fee_tiers: [0.01, 0.05, 0.30, 1.00] },
  ],
  SCROLL: [
    { id: 'uniswap_v3', name: 'Uniswap V3', default_fee: 0.30, fee_tiers: [0.01, 0.05, 0.30, 1.00] },
    { id: 'nuri',       name: 'Nuri Exchange', default_fee: 0.30, fee_tiers: [0.05, 0.30] },
    { id: 'sushi_v2',   name: 'SushiSwap V2', default_fee: 0.30, fee_tiers: [0.30] },
  ],
  BLAST: [
    { id: 'thruster_v3', name: 'Thruster V3', default_fee: 0.30, fee_tiers: [0.01, 0.05, 0.30, 1.00] },
    { id: 'thruster_v2', name: 'Thruster V2', default_fee: 0.30, fee_tiers: [0.30, 1.00] },
    { id: 'blasterswap', name: 'Blasterswap', default_fee: 0.30, fee_tiers: [0.30] },
  ],
  ZKSYNC: [
    { id: 'syncswap',   name: 'SyncSwap', default_fee: 0.30, fee_tiers: [0.05, 0.30] },
    { id: 'pancake_v3', name: 'PancakeSwap V3', default_fee: 0.25, fee_tiers: [0.01, 0.05, 0.25, 1.00] },
    { id: 'maverick',   name: 'Maverick V1', default_fee: 0.30, fee_tiers: [0.02, 0.05, 0.30] },
  ],
  MANTLE: [
    { id: 'agni_v3',      name: 'Agni Finance V3', default_fee: 0.25, fee_tiers: [0.01, 0.05, 0.25, 1.00] },
    { id: 'merchant_moe', name: 'Merchant Moe', default_fee: 0.30, fee_tiers: [0.30] },
    { id: 'fusionx_v3',   name: 'FusionX V3', default_fee: 0.30, fee_tiers: [0.01, 0.05, 0.30, 1.00] },
  ],
};

// ---------- Pure math (mirrors backend services/bundle_calc.py) ----------
export const calculateBundleResults = (inputs) => {
  const totalSupply = Number(inputs.totalSupply) || 0;
  const bundlePct = (Number(inputs.bundlePercentage) || 0) / 100;
  const initialLiq = Number(inputs.initialLiquidity) || 0;
  const basePrice = Number(inputs.baseCurrencyPrice) || 0;
  const tax = Math.max(0, Math.min(0.9999, (Number(inputs.taxRate) || 0) / 100));
  const dexFee = Math.max(0, Math.min(0.9999, (Number(inputs.dexFee) || 0) / 100));
  const feeRetention = (1 - tax) * (1 - dexFee);

  const zeros = {
    tokensInPool: totalSupply, tokensRemainingInPool: totalSupply,
    initialTokenPrice: 0, initialTokenPriceUsd: 0,
    finalTokenPrice: 0, finalTokenPriceUsd: 0,
    priceIncreaseMultiple: 0, bundleCost: 0, bundleCostUsd: 0,
    totalBaseInPool: initialLiq, totalBaseInPoolUsd: initialLiq * basePrice,
    fullyDilutedValueBase: 0, fullyDilutedValueUsd: 0,
    liquidityPoolValueUsd: 0, fdvToLpRatio: 0,
    walletDistribution: [],
    chain: inputs.chain, dex: inputs.dex,
    effectiveFeePct: (1 - feeRetention) * 100,
  };
  if (totalSupply <= 0 || initialLiq <= 0 || bundlePct >= 1 || feeRetention <= 0) return zeros;

  const initialTokensInPool = totalSupply;
  const initialTokenPrice = initialLiq / initialTokensInPool;
  const initialTokenPriceUsd = initialTokenPrice * basePrice;

  const tokensToBuy = bundlePct * totalSupply;
  const k = initialTokensInPool * initialLiq;
  const finalTokensInPool = Math.max(0.000001, initialTokensInPool - tokensToBuy);
  const finalBaseBeforeFee = k / finalTokensInPool;
  const bundleCost = (finalBaseBeforeFee - initialLiq) / feeRetention;

  const totalBaseInPool = finalBaseBeforeFee;
  const tokensRemainingInPool = finalTokensInPool;
  const finalTokenPrice = totalBaseInPool / tokensRemainingInPool;
  const finalTokenPriceUsd = finalTokenPrice * basePrice;

  const fdvBase = totalSupply * finalTokenPrice;
  const fdvUsd = fdvBase * basePrice;
  const lpValueUsd = 2 * totalBaseInPool * basePrice;
  const fdvToLpRatio = lpValueUsd > 0 ? fdvUsd / lpValueUsd : 0;
  const priceIncrease = initialTokenPrice > 0 ? finalTokenPrice / initialTokenPrice : 0;

  const walletDistribution = _calculateWalletDistribution(inputs, tokensToBuy, initialTokensInPool, initialLiq, feeRetention);

  return {
    tokensInPool: initialTokensInPool, tokensRemainingInPool,
    initialTokenPrice, initialTokenPriceUsd,
    finalTokenPrice, finalTokenPriceUsd,
    priceIncreaseMultiple: priceIncrease,
    bundleCost, bundleCostUsd: bundleCost * basePrice,
    totalBaseInPool, totalBaseInPoolUsd: totalBaseInPool * basePrice,
    fullyDilutedValueBase: fdvBase, fullyDilutedValueUsd: fdvUsd,
    liquidityPoolValueUsd: lpValueUsd, fdvToLpRatio,
    walletDistribution,
    chain: inputs.chain, dex: inputs.dex,
    effectiveFeePct: (1 - feeRetention) * 100,
  };
};

const _calculateWalletDistribution = (inputs, totalTokensToBuy, initialTokensInPool, initialLiquidity, feeRetention) => {
  const wallets = [];
  const totalSupply = Number(inputs.totalSupply) || 0;
  const maxWalletDecimal = (Number(inputs.maxWalletPercent) || 0) / 100;
  const walletCount = Math.max(1, Number(inputs.walletCount) || 1);
  const basePrice = Number(inputs.baseCurrencyPrice) || 0;

  let currentTokensInPool = initialTokensInPool;
  let currentBaseInPool = initialLiquidity;
  const k = initialTokensInPool * initialLiquidity;
  let remaining = totalTokensToBuy;
  let walletNumber = 1;

  const hardCap = maxWalletDecimal > 0 ? 1000 : walletCount;

  while (remaining > 0.001 && walletNumber <= hardCap) {
    let tokensToAcquire;
    if (maxWalletDecimal > 0) {
      const perWallet = totalSupply * maxWalletDecimal;
      tokensToAcquire = Math.min(perWallet, remaining);
    } else {
      const walletsLeft = walletCount - walletNumber + 1;
      if (walletsLeft <= 0) break;
      tokensToAcquire = remaining / walletsLeft;
    }
    if (tokensToAcquire <= 0) break;

    const newTokens = currentTokensInPool - tokensToAcquire;
    if (newTokens <= 0) break;
    const newBase = k / newTokens;
    const cost = (newBase - currentBaseInPool) / feeRetention;

    wallets.push({
      walletNumber, tokensHeld: tokensToAcquire,
      supplyPercentage: totalSupply > 0 ? (tokensToAcquire / totalSupply) * 100 : 0,
      costInBase: cost, costInUsd: cost * basePrice,
    });
    currentTokensInPool = newTokens;
    currentBaseInPool = newBase;
    remaining -= tokensToAcquire;
    walletNumber += 1;
  }
  return wallets;
};

export const calculateRequiredWallets = (totalSupply, bundlePercentage, maxWalletPercent) => {
  if (!maxWalletPercent || maxWalletPercent <= 0) return 0;
  const tokensToBuy = (bundlePercentage / 100) * totalSupply;
  const perWallet = (maxWalletPercent / 100) * totalSupply;
  return perWallet > 0 ? Math.ceil(tokensToBuy / perWallet) : 0;
};

// ---------- API (used for live prices + chain metadata) ----------
export const fetchBundleChains = async () => (await bundleClient.get('/chains')).data;
export const fetchBundlePrices = async () => (await bundleClient.get('/prices')).data;
export const fetchBundleCalculate = async (inputs) => (await bundleClient.post('/calculate', inputs)).data;
